export default __webpack_public_path__ + "static/media/grafema_angura_03.89dcd0b2.mp4";